/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VcoAuthenticatedUserWithSummaryDto } from '../../models/vco-authenticated-user-with-summary-dto';

export interface GetAuthInfo$Params {
}

export function getAuthInfo(http: HttpClient, rootUrl: string, params?: GetAuthInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<VcoAuthenticatedUserWithSummaryDto>> {
  const rb = new RequestBuilder(rootUrl, getAuthInfo.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VcoAuthenticatedUserWithSummaryDto>;
    })
  );
}

getAuthInfo.PATH = '/auth';
